import { EventEmitter } from "@angular/core";
import { ColumnModel } from "../../shared/models/column.model";
import { QuoteModel } from "../../shared/models/quote.model";
export class QuoteBuildData{
    module = {
        name: "Quote",
        new_name: "quote",
        has_dot_menu: true,
        icon:'fa-browser',
        permission:'quote',
        filtered_name: null
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:QuoteModel) => {//Generates Row for codeblack-table
        return QuoteModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Quote No",
            prop: "id",
            flex_grow: 1,
            row_accessor: "quote_no",
            class:""//force-flex force-flex-end
        },
        {
            title: "Quote Date",
            prop: "created_at_formatted",
            flex_grow: 3,
            row_accessor: "created_at_formatted",
        },
        {
            title: "Customer Reference",
            prop: "customer.reference_no_with_name",
            flex_grow: 3,
            row_accessor: "customer_reference_no",
        },
		{
            title: "Status",
            prop: "status",
            flex_grow: 2,
            row_accessor: "status"
        },
		
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}